/*jshint esversion: 6 */

import $ from 'jquery';

function productNavigation() {

//  console.log('shopNavigation');

  $('.page-header__product-navigation >ul >li.sub').prepend('<span class="before-icon"></span>');
  $('.page-header__product-navigation >ul >li.sub >.before-icon').on('click', event => {
    let $icon = $(event.currentTarget);
    let $li = $icon.parent();
    let $ul = $li.find('>ul');

    $li.toggleClass('open');
    $ul.slideToggle();
  });

  $('.page-header__product-navigation .lvl-1 >li.sub').prepend('<span class="before-icon"></span>');
  $('.page-header__product-navigation .lvl-1 >li >.before-icon').on('click', event => {
    let $icon = $(event.currentTarget);
    let $li = $icon.parent();
    let $ul = $li.find('>ul');

    $li.toggleClass('open');
    $ul.slideToggle();
  });
}

export default productNavigation;
